import classNames from 'classnames';
import { Button, TYPE } from '@hub/common/Button/Button';
import { Icon, IconColor, IconID } from '@hub/common/Icon/Icon';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { usePiwikPro } from '@piwikpro/next-piwik-pro';

import { IbhEventCategory, TrackedIbhEventActions } from '@hub/bearing-hub/common/tracking.config';
import { getLocale } from '@hub/libs/constants';
import { EXTERNAL_LINKS } from '@hub/libs/redirect.helper';
import { useRouter } from 'next/router';

export type IsFitBoxProps = {
  articleNumber: string;
  articleTitle: string;
  isCustom: boolean;
  onServiceLifeModalOpen: (isOpen: boolean) => void;
};

export const IsFitBox = ({ onServiceLifeModalOpen, articleNumber, isCustom, articleTitle }: IsFitBoxProps) => {
  const { t } = useTranslation();
  const { CustomEvent } = usePiwikPro();
  const router = useRouter();
  const locale = getLocale(router);

  return (
    <div className="flex lg:justify-end">
      <div className={classNames('bg-gray-50', 'p-8', 'lg:ml-auto', 'lg:w-3/4')}>
        <div className="text-3xl mb-4" data-testid="is-fit-box_header">
          {t('DECISION_TOOLS_BOX.LABEL', { ns: 'bearing-hub/bearingHub' })}
        </div>
        <Button
          icon={<Icon size={10} color={IconColor.WHITE} id={IconID.LIFETIME_CALCULATOR} />}
          text={t('LIFETIME.CALCULATE_SERVICE_LIFE', { ns: 'bearing-hub/bearingHub' })}
          type={TYPE.SECONDARY}
          onClick={() => {
            CustomEvent.trackEvent(IbhEventCategory, TrackedIbhEventActions.serviceLifeOpen);
            onServiceLifeModalOpen(true);
          }}
          testId="is-fit-box--open-life-time-modal"
        />
        {!isCustom && (
          <Button
            onClick={() => {
              window.location.href = EXTERNAL_LINKS.SAMPLE(articleNumber, articleTitle, locale);
            }}
            icon={<Icon size={10} color={IconColor.WHITE} id={IconID.FREE_SAMPLE} />}
            text={t('IS_IT_FIT_BOX.ORDER_FREE_SAMPLE', { ns: 'bearing-hub/bearingHub' })}
            type={TYPE.PRIMARY}
            testId="is-fit-box--request-free-sample"
          />
        )}
        {locale === 'de-DE' && (
          <Button
            onClick={() => {
              window.location.href = 'https://www.igus.de/gleitlager/wiki/toleranzen';
            }}
            icon={<Icon size={10} color={IconColor.WHITE} id={IconID.HANDY_MAN} />}
            text={t('IS_IT_FIT_BOX.INSTALLATION_RECOMMENDATION', { ns: 'bearing-hub/bearingHub' })}
            type={TYPE.SECONDARY}
            testId="is-fit-box--installations-recommendation"
          />
        )}
      </div>
    </div>
  );
};
